import axios from "axios";
import { getThreadsByUserId } from "./GroupAction";

const REACT_APP_MICRO_CHAT_URL = process.env.REACT_APP_MICRO_CHAT_URL;

export const getFriendsByUserId = (id) => (dispatch) => {
  axios.get(`${REACT_APP_MICRO_CHAT_URL}/friends/${id}`).then((response) => {
    dispatch({
      type: "GET_FRIEND_BY_USER_ID",
      data: response.data.data,
    });
  });
};
export const getPendingFriendsByUserId = (id) => (dispatch) => {
  axios
    .get(`${REACT_APP_MICRO_CHAT_URL}/friends/pending/${id}`)
    .then((response) => {
      dispatch({
        type: "GET_PENDING_FRIEND_ID",
        data: response.data.data,
      });
    });
};
export const getBySenderAndReceiver = (sender, receiver) => (dispatch) => {
  axios
    .get(`${REACT_APP_MICRO_CHAT_URL}/friends/one/${sender}/${receiver}`)
    .then((response) => {
      dispatch({
        type: "GET_SENDER_RECEIVER_FRIEND_ID",
        data: response.data.data,
      });
    });
};
export const insertFriend = (data) => (dispatch) => {
  axios
    .post(`${REACT_APP_MICRO_CHAT_URL}/friends`, data)
    .then(() => {
      dispatch({
        type: "INSERT_FRIEND_SUCCESS",
      });

      dispatch(getFriendsByUserId(data.sender));
      dispatch(getPendingFriendsByUserId(data.sender));
      dispatch(getThreadsByUserId(1, data.sender));
    })
    .catch((err) => {
      dispatch({
        type: "INSERT_FRIEND_FAILED",
        payload: err.response,
      });
    });
};
export const removeFriend = (sender_id, receiver_id) => (dispatch) => {
  axios
    .delete(`${REACT_APP_MICRO_CHAT_URL}/friends/${sender_id}/${receiver_id}`)
    .then(() => {
      dispatch({
        type: "REMOVE_FRIEND_SUCCESS",
      });
    })
    .catch((err) => {
      dispatch({
        type: "REMOVE_FRIEND_FAILED",
        payload: err.response,
      });
    });
};
